import { connect } from 'react-redux';
import { operations as reactionOperations } from '../../../../../../store/reactions';
import { accessingCurrentSpaceAsStaff } from '../../../../../../../core/selectors/classroom';

import PostCell from './PostCell';

const mapStateToProps = (state) => ({
  isReadOnlyUser: accessingCurrentSpaceAsStaff(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  toggleReaction: ({ emojiName }) =>
    dispatch(
      reactionOperations.toggleReaction({
        emojiName,
        itemId: ownProps.post.objectId,
        itemType: 'UBClassRoomPost',
      })
    ),
});

const PostCellContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostCell);

export default PostCellContainer;
